import {
  ApplicationFeature,
  CompanyFeatureFunctionalityDto,
} from "@green0meter/api-client";
import { isEmpty } from "lodash";

export const hasFeature = (
  features: CompanyFeatureFunctionalityDto[] | undefined,
  feature: ApplicationFeature,
): boolean => {
  return features?.some((f) => f.applicationFeature === feature) ?? false;
};

export const hasOnlyFeature = (
  features: CompanyFeatureFunctionalityDto[] | undefined,
  feature: ApplicationFeature,
): boolean => {
  if (features && isEmpty(features)) return false;

  return (
    features?.length === 1 && features?.some((f) => f.applicationFeature === feature)
  );
};

export const hasAnyFeature = (
  features: CompanyFeatureFunctionalityDto[] | undefined,
  featureList: ApplicationFeature[],
): boolean => {
  if (!features || isEmpty(featureList)) return false;

  return features.some(
    (f) =>
      f.applicationFeature !== undefined &&
      featureList.includes(Number(f.applicationFeature) as ApplicationFeature),
  );
};
